module.exports = {
	"name": "cw-galatea-agent-ui",
	"version": "125.20231211.13",
	"private": true,
	"homepage": ".",
	"dependencies": {
		"@babel/polyfill": "7.12.1",
		"babel-plugin-transform-class-properties": "6.24.1",
		"bootstrap": "5.1.3",
		"cw-galatea-agent-controller-js": "git+ssh://git@bitbucket.org/nuxibatechnologies/cw-galatea-agent-controller.git#2022.1.2",
		"cw-galatea-api-js": "git+ssh://git@bitbucket.org/nuxibatechnologies/cw-galatea-api-js.git#2023.828.0",
		"cw-unified-inbox": "git+ssh://git@bitbucket.org/nuxibatechnologies/cw-unified-inbox.git#2.4.4",
		"es6-promise": "^4.1.0",
		"global-audio-player-js": "git+ssh://git@bitbucket.org/nuxibatechnologies/global-audio-player-js.git",
		"global-common-utilities-js": "git+ssh://git@bitbucket.org/nuxibatechnologies/global-common-utilities-js.git",
		"global-components-library": "git+ssh://git@bitbucket.org/nuxibatechnologies/global-components-library.git#1.98.0",
		"global-logger-services-js": "git+ssh://git@bitbucket.org/nuxibatechnologies/global-logger-services-js.git",
		"global-web-socket-client-js": "git+ssh://git@bitbucket.org/nuxibatechnologies/global-web-socket-client-js.git",
		"i18next": "19.9.2",
		"moment-range": "3.0.3",
		"node-sass-chokidar": "0.0.3",
		"react": "16.14.0",
		"react-autosize-textarea": "3.0.1",
		"react-bootstrap": "0.31.0",
		"react-bootstrap-select": "0.14.0",
		"react-datepicker": "0.60.2",
		"react-dom": "16.14.0",
		"react-draggable": "4.4.5",
		"react-html-parser": "1.0.3",
		"react-i18next": "11.15.3",
		"react-modal": "3.14.4",
		"react-preload": "0.5.1",
		"react-redux": "7.2.6",
		"react-resizable": "1.11.1",
		"react-simple-pie-chart": "0.4.1",
		"react-simple-range": "1.6.0",
		"react-table": "6.7.4",
		"reactstrap": "8.10.1",
		"redux": "3.6.0",
		"redux-actions": "2.6.1",
		"redux-thunk": "2.4.1",
		"regenerator-runtime": "0.13.9"
	},
	"devDependencies": {
		"@babel/cli": "^7.16.8",
		"@babel/core": "^7.16.7",
		"@babel/plugin-transform-regenerator": "^7.16.7",
		"@babel/preset-env": "^7.16.11",
		"@babel/preset-react": "^7.16.7",
		"javascript-obfuscator": "^0.24.6",
		"node-sass-chokidar": "0.0.3",
		"npm-run-all": "^4.0.2",
		"react-scripts": "^0.9.5",
		"sonarqube-scanner": "^2.8.2"
	},
	"scripts": {
		"build-css": "node-sass-chokidar ./node_modules/cw-unified-inbox/dist -o ./node_modules/cw-unified-inbox/dist && node-sass-chokidar ./node_modules/global-components-library/dist -o ./node_modules/global-components-library/dist && node-sass-chokidar ./src -o ./src",
		"watch-css": "npm run build-css && node-sass-chokidar --include-path ./src --include-path ./node_modules/ src/ -o src/ --watch",
		"start-js": "react-scripts start",
		"start": "npm-run-all -p watch-css start-js",
		"parse-slate": "babel --plugins @babel/plugin-transform-regenerator ./node_modules/slate/dist/index.js -o ./node_modules/slate/dist/index.js",
		"build": "npm run parse-slate && npm run build-css && react-scripts build && call Obfuscator.bat && call AfterObfuscation.bat",
		"buildWithoutObfuscation": "npm run parse-slate && npm run build-css && react-scripts build",
		"test": "react-scripts test --env=jsdom",
		"obfuscate": "Obfuscator.bat && call AfterObfuscation.bat",
		"eject": "react-scripts eject",
		"install-dependencies": "npm install --legacy-peer-deps",
		"sonarScanner": "node sonarqube-scanner.js CW_Galatea_Agent_UI_DEV",
		"sonarScanner:release": "node sonarqube-scanner.js CW_Galatea_Agent_UI_RELEASE"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 2050
// module chunks = 0